import newFormFieldsData from "@/data/pre-trip-fields.json";
import { KForm, KTextField, KTextarea } from "kinnect-general";
import { formatDate } from "kinnect-formatters";
import {
	VCheckbox,
	VCol,
	VContainer,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemSubtitle,
	VListItemTitle,
	VRow,
	VSubheader,
	VSwitch
} from "vuetify/lib";

export default KForm.extend( {
	name: "KTruckPreTripForm",

	props: {
		idTruck: {
			required: true,
			type: Number
		},
		preTrip: Object
	},

	data: () => ( {
		formFields: {
			odometer: null,
			notes: null,
			data: {}
		},
		signed: null
	} ),

	computed: {
		viewing() {
			return Boolean( this.preTrip );
		},

		formUrl() {
			if ( this.viewing ) {
				return null;
			}

			return `yard/trucks/${this.idTruck}/pretrips`;
		},

		fieldsData() {
			if ( this.viewing ) {
				return newFormFieldsData.map( section => ( {
					...section,
					fields: section.fields.filter( field =>
						this.preTrip.data.hasOwnProperty( field.key )
					)
				} ) );
			}

			return newFormFieldsData.map( section => ( {
				...section,
				fields: section.fields.filter( field => field.active )
			} ) );
		},

		internalRedirect() {
			if ( this.redirect ) {
				return this.redirect;
			}

			return [ "back", {
				name: "yardTruckPreTrips",
				params: { idTruck: this.idTruck }
			} ];
		},

		internalFormTitle() {
			if ( this.formTitle ) {
				return this.formTitle;
			}

			if ( this.viewing ) {
				return `Pre-Trip from ${formatDate( this.preTrip.created_at )}`;
			}
		}
	},

	watch: {
		fieldsData: {
			handler( fieldsData ) {
				fieldsData.forEach( section => {
					section.fields.forEach( field => {
						this.$set( this.formFields.data, field.key, this.viewing ? this.preTrip.data[field.key] : false );
					} );
				} );
			},
			deep: true,
			immediate: true
		},

		preTrip( preTrip ) {
			Object.keys( this.formFields ).forEach( key => {
				if ( preTrip.hasOwnProperty( key ) ) {
					this.formFields[key] = preTrip[key];
				}
			} );
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formFields,
				formTitle: this.internalFormTitle,
				method: "post",
				readonly: this.viewing,
				redirect: this.internalRedirect
			}}
			on={this.$listeners}
		>
			{this.fieldsData.map( section =>
				<VList class="list--auto-height" key={section.label}>
					<VSubheader class="text-subtitle-1">Inspection: {section.label}</VSubheader>

					{section.fields.map( field =>
						<VListItem
							key={field.label}
							onClick={() => {
								if ( !this.viewing ) {
									this.formFields.data[field.key] = !this.formFields.data[field.key];
								}
							}}
						>
							<VListItemAction>
								<VSwitch
									color="accent"
									hideDetails
									inputValue={this.formFields.data[field.key]}
									inset
									onChange={val => ( this.viewing ? null : this.formFields.data[field.key] = val )}
									onClick={e => e.stopPropagation()}
									readonly={this.viewing}
									ripple={!this.viewing}
								></VSwitch>
							</VListItemAction>

							<VListItemContent>
								<VListItemTitle>{field.label}</VListItemTitle>
								<VListItemSubtitle>{field.hint}</VListItemSubtitle>
							</VListItemContent>
						</VListItem>
					)}
				</VList>
			)}

			<VContainer fluid>
				<VRow>
					<VCol cols={12}>
						<KTextField
							disabled={this.viewing}
							label="Odometer Reading*"
							onInput={val => this.formFields.odometer = val ? parseFloat( val ) : null}
							required
							type="number"
							validationName="odometer reading"
							validationRules="required|numeric"
							value={this.formFields.odometer}
						></KTextField>
					</VCol>

					<VCol cols={12}>
						<KTextarea
							disabled={this.viewing}
							label="Notes"
							vModel={this.formFields.notes}
						></KTextarea>
					</VCol>

					<VCol cols={12}>
						<VCheckbox
							color="accent"
							falseValue={null}
							inputValue={this.viewing ? true : this.signed}
							inset
							label="I have personally inspected the vehicle above, and have found it to be in the condition listed above.*"
							onChange={val => this.signed = val}
							readonly={this.viewing}
							required
							ripple={!this.viewing}
							trueValue={true}
							type="checkbox"
							validationRules="required"
						></VCheckbox>
					</VCol>
				</VRow>
			</VContainer>
		</KForm>;
	}
} );
